import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

type ConfirmFn = () => Promise<boolean>;

export function useConfirmExit(confirmFn: ConfirmFn, shouldBlock: boolean) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldBlock && currentLocation.pathname !== nextLocation.pathname,
  );

  const isConfirmingRef = useRef(false);

  useEffect(() => {
    if (blocker.state === 'blocked' && !isConfirmingRef.current) {
      isConfirmingRef.current = true;

      confirmFn()
        .then((confirmed) => {
          if (confirmed) {
            blocker.proceed();
          } else {
            blocker.reset();
          }
        })
        .finally(() => {
          isConfirmingRef.current = false;
        });
    }
  }, [blocker, confirmFn]);
}
